<template lang="pug">
  vm-prompt(vm-size="small" @vm-cancel="close" @vm-accept="save" @vm-close="close" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-active="isModalEmployeeVisible" :vm-title='getTitle')
    .group
      vm-row.separador(vm-type="flex" vm-w="12" v-for="(column, index) in employees")
        vm-col(vm-justify="center", vm-align="center", vm-w=9)
          h3 {{ employees[index]['contact'] }}:
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
          toogle(:flag="employees_flag[index]" @selected="selectEmployee(employees[index]['id'])" @unselected="unSelectEmployee(employees[index]['id'])")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ToQuotes')

export default {
  name: 'ModalSelectEmployee',
  components: {
    toogle: () => import('@/components/aditionals/ToogleSelect.vue')
  },
  props: {
    project_id: {
      type: Number
    },
    employees_flag: {
      type: Array
    },
    selected_employees: {
      type: Array
    }
  },
  computed: {
    ...mapGetters([
      'isModalEmployeeVisible',
      'employees'
    ]),
    getTitle () {
      return this.$t('projects.team')
    }
  },
  methods: {
    ...mapActions([
      'selectEmployees',
      'setModalEmployeeVisible',
      'saveEmployees',
      'loadToQuotes'
    ]),
    close () {
      this.setModalEmployeeVisible(false)
    },
    selectEmployee (index) {
      this.selected_employees.push(index)
    },
    unSelectEmployee (index) {
      const i = this.selected_employees.indexOf(index)
      this.selected_employees.splice(i, 1)
    },
    async save () {
      await this.saveEmployees({ id: this.project_id, employees: this.selected_employees }).then(() => {
        this.loadToQuotes({ page: 1, customer: this.employees[0].employer_id })
        this.selected_employees = []
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.separador {
  padding-bottom: 10px;
}
.group {
  padding: 15px;
}
</style>
